export default __webpack_public_path__ + "static/media/fr5.0c190ee0.jpg";